//
//
//
//
//
//
//
//

export default {
    name: "contentDetail",
    data() {
        return {
            id: 0,
            content: {}
        }
    },
    methods: {
        getGraphicInformationByBusiness() {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + this.id + '&businessType=content.remarks').then(res => {
                this.content = {};
                this.content = res.data.result;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getGraphicInformationByBusiness();

    }
}
